/* hs-eslint ignored failing-rules */
/* eslint-disable no-bitwise */

import { canReadText, canReadTextV2, hexToRGB } from 'MeetingsBase/utils/color';
function expandHexShorthand(hex) {
  if (hex.length === 4 && hex.startsWith('#')) {
    // Convert #abc to #aabbcc
    return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
  }
  return hex;
}
export function getColorStyleWithOpacity(primaryColor, opacity = 0.05) {
  const rgb = hexToRGB(primaryColor);
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
}
export function shadeColor(color, percent) {
  /**
   * Source code from: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
   * @param {string} color - A hex color string (must start with #)
   * @param {int} percent - Percentage by which to lighten the color, can be negative
   * to darken color
   * @returns {string} color - A color, lightened by the given percentage
   */
  const num = parseInt(color.slice(1), 16);
  let red = (num >> 16) + percent;
  if (red > 255) red = 255;else if (red < 0) red = 0;
  let blue = (num >> 8 & 0x00ff) + percent;
  if (blue > 255) blue = 255;else if (blue < 0) blue = 0;
  let green = (num & 0x0000ff) + percent;
  if (green > 255) green = 255;else if (green < 0) green = 0;
  return `#${(green | blue << 8 | red << 16).toString(16)}`;
}
export function getPrimaryButtonStyle(primaryColor, theme) {
  if (shouldUseDefaultStyles(primaryColor)) {
    return {
      backgroundColor: null,
      borderColor: null,
      color: null
    };
  }
  return {
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    color: canReadText(primaryColor, theme.color['text-primary-default']) ? theme.color['text-primary-default'] : theme.color['text-core-default']
  };
}
export function getPrimaryButtonHoverStyle(primaryColor, theme) {
  if (shouldUseDefaultStyles(primaryColor)) {
    return {
      backgroundColor: null,
      borderColor: null,
      color: null
    };
  }
  return {
    backgroundColor: shadeColor(primaryColor, 20),
    borderColor: shadeColor(primaryColor, 20),
    color: canReadText(primaryColor, theme.color['text-primary-default']) ? theme.color['text-primary-default'] : theme.color['text-core-default']
  };
}
export function getSecondaryButtonStyle(primaryColor, theme) {
  if (shouldUseDefaultStyles(primaryColor)) {
    return {
      borderColor: null,
      color: null
    };
  }
  return {
    borderColor: primaryColor,
    color: canReadTextV2(theme.color['fill-surface-default'], primaryColor) ? primaryColor : theme.color['text-core-default']
  };
}
export function getSecondaryButtonHoverStyle(primaryColor, theme) {
  if (shouldUseDefaultStyles(primaryColor)) {
    return {
      backgroundColor: null,
      borderColor: null,
      color: null
    };
  }
  return {
    backgroundColor: getColorStyleWithOpacity(primaryColor),
    borderColor: primaryColor,
    color: canReadTextV2(theme.color['fill-surface-default'], primaryColor) ? primaryColor : theme.color['text-core-default']
  };
}
export function shouldUseDefaultStyles(primaryColor) {
  const defaultColorSet = new Set(['#FFFFFF']);
  return defaultColorSet.has(expandHexShorthand(primaryColor).toUpperCase());
}